import React from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";

export const ListBankAccounts = ({ accounts, onVerify }) => {
  return (
    <div>
      <label className="form-label">Accounts</label>
      {!accounts ||
        (accounts.length == 0 && (
          <div className="font-size-2">No accounts</div>
        ))}
      {accounts && accounts.length > 0 && (
        <ListGroup className="font-size-2 mb-4">
          {accounts.map((account) => {
            return (
              <ListGroupItem key={account.id}>
                {account.bankName} - {account.name}
                {account.status === "unverified" && onVerify && (
                  <a
                    onClick={() => {
                      onVerify(account);
                    }}
                    className="text-secondary fw-bold ms-2 font-size-4 cursor-pointer"
                  >
                    Verify
                  </a>
                )}
                {!onVerify && (
                  <span className="ps-1 text-capitalize">
                    <b>({account.status})</b>
                  </span>
                )}
              </ListGroupItem>
            );
          })}
        </ListGroup>
      )}
    </div>
  );
};
